// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const scraggy: PokeData = {
  "id": 559,
  "name": "scraggy",
  "height": 6,
  "weight": 118,
  "base_experience": 70,
  "types": [
    PokeType.DARK,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "sand-attack",
    "headbutt",
    "leer",
    "low-kick",
    "high-jump-kick",
    "protect",
    "scary-face",
    "feint-attack",
    "swagger",
    "crunch",
    "beat-up",
    "torment",
    "facade",
    "focus-punch",
    "brick-break",
    "payback",
    "rock-climb",
    "head-smash",
    "chip-away"
  ],
  "moves": [
    "headbutt",
    "leer",
    "protect",
    "scary-face",
    "crunch",
    "quash",
    "vacuum-wave",
    "seismic-toss",
    "dark-pulse",
    "snatch",
    "superpower",
    "meteor-assault",
    "lash-out"
  ],
  "evolution_chain": {
    "id": 285,
    "item": null,
    "species": [
      {
        "name": "scraggy",
        "order": 560,
        "types": [
          PokeType.DARK,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "scrafty",
        "order": 561,
        "types": [
          PokeType.DARK,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 559,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 39,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 60,
    "speed": 48,
    "ability_power": 75
  },
  "stat_changes": [],
  "catch_rate": 180,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
